import { Navigate } from 'react-router-dom';
import { useCompany } from '../context/CompanyContext';
import './Setup.css';

function RootRedirect() {
  const { companies, loading, error } = useCompany();

  if (loading) {
    return <div className="setup-loading">Loading Krosifin...</div>;
  }

  if (error) {
    return <div className="setup-loading">Backend unreachable: {error}</div>;
  }

  return <Navigate to={companies.length > 0 ? '/dashboard' : '/setup'} replace />;
}

export default RootRedirect;
